export default __webpack_public_path__ + "static/media/trailer_1_3.b6f1efc1.svg";